export default {
    'diagram3b4-4': {
        'diagram-task': 'Inductive',
        'diagram-peak': 'Weaker economies facing a down-turn are forced to use high unemployment to restore their prospects',
        'diagram-hint': 'Why is that the only way?',
        'diagram-answers': {
            '1': 'Can’t use taxation and spending to boost the economy',
            '2': 'Can’t avoid using high unemployment to force down labor costs',
            '3': 'Can’t raise or lower interest rates to control the money supply'
        },
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/3/3b4/diagram4/i18n/en.js